import firebase from "firebase";
import router from "@/router/index.js";
import { db } from "../../main";

const state = {
  user: null,
  email: null,
  redirect: null,
  loading: false,
  error: null
};

const getters = {
  user(state) {
    return state.user;
  },
  getEmail(state) {
    return state.email;
  },
  redirect(state) {
    return state.redirect;
  },
  loading(state) {
    return state.loading;
  },
  getError(state) {
    return state.error;
  }
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setEmail(state, payload) {
    state.email = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
  }
};
const actions = {
  signInUser({ commit, getters, dispatch }, payload) {
    commit("setLoading", true);
    commit("clearError", false);
    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(user => {
        const newUser = {
          id: user.user.uid,
          email: user.user.email
        };
        db.collection("users")
          .where("id", "==", newUser.id)
          .get()
          .then(snapshot => {
            if (snapshot.docs.length > 0) {
              snapshot.docs.forEach(doc => {
                let usr = doc.data();
                usr = Object.assign(newUser, usr);
                commit("setUser", usr);
                localStorage.setItem("user", JSON.stringify(usr));
              });
            } else {
              commit(
                "setError",
                "This account is probably customer not administrator"
              );
              dispatch("signOut");
            }
          })
          .then(() => {
            const user = getters.user;
            if (user.type === "admin") {
              router.push("/dashboard");
            } else {
              router.push("/helpdesk");
            }
            commit("setLoading", false);
          });
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
      });
  },
  autoSignIn({ commit, getters }, payload) {
    db.collection("users")
      .where("id", "==", payload.uid)
      .get()
      .then(snapshot => {
        if (snapshot.docs.length > 0) {
          snapshot.docs.forEach(doc => {
            let usr = doc.data();
            commit("setUser", usr);
            localStorage.setItem("user", JSON.stringify(usr));
          });
        } else {
          commit(
            "setError",
            "This account is probably customer not administrator"
          );
        }
      })
      .then(() => {
        const user = getters.user;
        if (user.type === "admin") {
          router.push("/dashboard");
        } else {
          router.push("/helpdesk");
        }
      });
  },
  signOut({ commit }) {
    commit("setLoading", true);
    firebase
      .auth()
      .signOut()
      .then(() => {
        localStorage.removeItem("user");
        router.push("/login");
        commit("setUser", "");
        commit("setLoading", false);
      });
  },
  isLoading({ commit }, payload) {
    commit("setLoading", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
